<div class="unauthorised-container">
    <public-header *ngIf="showHeader" class="public-header"></public-header>
    <header id="register_image">
        <section id="image-placeholder"></section>
    </header>
    <article class="content-container">
        <div class="logo" *ngIf="!showHeader">
            <div id="logo-placeholder"></div>
        </div>
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </article>
</div>
